import { API, dailyLimitTier, openLimitModal } from "@/lib/api";

// Reads a Server-Sent Events stream from POST /ai/chat/stream via fetch.
export async function streamChat({ prompt, mode, language, conversationId, history, deepResearch, onStart, onDelta, onDone, onError, onResearch }) {
  let resp;
  try {
    resp = await fetch(`${API}/ai/chat/stream`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        prompt,
        mode,
        language,
        conversation_id: conversationId || null,
        history: history || [],
        deep_research: !!deepResearch,
      }),
    });
  } catch {
    onError?.({ kind: "temporary" });
    return;
  }

  if (!resp.ok || !resp.body) {
    let detail = null;
    try { detail = (await resp.json())?.detail; } catch { /* ignore */ }
    if (resp.status === 429) {
      const tier = dailyLimitTier(detail);
      if (tier) {
        openLimitModal(tier);
        onError?.({ kind: "limit", tier });
        return;
      }
      // per-minute abuse guard / high demand — a plain temporary retry.
      onError?.({ kind: "temporary" });
      return;
    }
    onError?.({ kind: "temporary" });
    return;
  }

  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    let idx;
    while ((idx = buffer.indexOf("\n\n")) >= 0) {
      const raw = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const lines = raw.split("\n");
      let event = "message";
      let dataStr = "";
      for (const line of lines) {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) dataStr += line.slice(5).trim();
      }
      if (!dataStr) continue;
      let data;
      try {
        data = JSON.parse(dataStr);
      } catch {
        continue;
      }
      if (event === "start") onStart?.(data);
      else if (event === "research") onResearch?.(data);
      else if (event === "done") onDone?.(data);
      else if (event === "error") onError?.({ kind: data.code || "temporary" });
      else if (data.delta != null) onDelta?.(data.delta);
    }
  }
}
